export const MaterialIcons = require('./icons.ttf');
